export const conf = {
  rest: {
    baseUrl: 'https://crawler.matttrevithick.com/crawler-api',
    reportUrl: 'https://crawler.matttrevithick.com/sentiment-report-api'

    // baseUrl: 'http://localhost/crawler-api',
    // reportUrl: 'http://localhost/sentiment-report-api'
  },
};
